import { UrlMatchResult, UrlSegment } from '@angular/router';
import { RegexUrlMatcher } from './shared/model/classes/regex-url-matcher';

export function getPaidPathMatcher(url: UrlSegment[]) {
  const path = url.join('/');

  if (path.startsWith('get-paid')) {
    return { consumed: [url[0]] };
  }

  return null;
}

export function qualityControlUrlMatcher(url: UrlSegment[]): UrlMatchResult | null {
  const QC_PATH = 'quality-control-report';
  const isOnQualityControlPage = url[0].path === QC_PATH;
  const hasIdParam = isOnQualityControlPage ? url[1]?.path && /^\d+$/.test(url[1].path) : null;

  if (url.length === 2 && isOnQualityControlPage && hasIdParam) {
    return {
      consumed: url,
      posParams: {
        id: url[1]
      }
    };
  }
  return null;
}

export function feedPathMatcher(url: UrlSegment[]) {
  const path = url.join('/');

  if (path.startsWith('feed')) {
    return { consumed: [url[0]] };
  }

  return null;
}

export function chatPathMatcher(url: UrlSegment[]) {
  const path = url && url[0] && url[0]['path'];

  if (path === 'chat') {
    return { consumed: url };
  }

  return null;
}

export function cmsPageLandingUrlMatcher(url: UrlSegment[]): UrlMatchResult | null {
  const LANDING_PREFIX = 'l';
  if (url.length > 0 && url[0].path === LANDING_PREFIX) {
    return { consumed: url };
  }
  return null;
}

export function productMatcher(url: UrlSegment[]) {
  let regexUrlMatcher: RegexUrlMatcher;
  regexUrlMatcher = new RegexUrlMatcher();
  const regExp = new RegExp(/.*\/.*\/.*\/.*-([0-9]+)\.shtml$/);
  return regexUrlMatcher.getRegexUrlMatcherRegexUrlMatcher(url, regExp, ['id']);
}

export function journalMainUrlMatcher(url: UrlSegment[]): UrlMatchResult | null {
  const JOURNAL_PATH = 'journal';

  if (
    url.length > 0 &&
    url[0].path === JOURNAL_PATH &&
    (url.length === 1 || url[1].path === '' || url[1].path.includes('p-') || url[1].path === 'cat')
  ) {
    return { consumed: url };
  }
  return null;
}

export function cmsPageEditoUrlMatcher(url: UrlSegment[]): UrlMatchResult | null {
  const EDITO_PREFIX = 'journal';
  if (url.length > 0 && url[0].path === EDITO_PREFIX) {
    return { consumed: url };
  }
  return null;
}

export function affiliationMatcher(url: UrlSegment[]) {
  const affiliationPath = [
    'affiliation.shtml',
    'affiliate-program.shtml',
    'affiliate-programm.shtml',
    'programa-de-afiliacion.shtml',
    'programma-di-affiliazione.shtml'
  ];
  return url.length > 0 && affiliationPath.includes(url[0].path) ? { consumed: url } : null;
}

export function notFoundMatcher(url: UrlSegment[]): UrlMatchResult {
  return url.length >= 1 && url[0].path === 'not-found' ? { consumed: url } : null;
}

export function professionalSellersUrlMatcher(url: UrlSegment[]) {
  const professionalSellersPaths = [
    'professional-sellers',
    'vendeurs-professionnels',
    'professionelle-verkaufer',
    'vendedores-profesionales',
    'venditori-professionisti'
  ];
  return url.length > 0 && professionalSellersPaths.includes(url[0].path) ? { consumed: url } : null;
}
